<template>
  <div class="row w-100">
    <div class="card w-100">
      <div class="card-header">
        <div class="w-100 d-flex justify-content-between">
          <h5>#{{ course.id }} - {{ course.name }}</h5>
          <div>
            <button v-if="course.was_approved" @click="courseIsOk(false)" class="btn btn-sm btn-danger mr-1" :disabled="loading">
              <i class="fa fa-times-circle" /> Bloquear Curso
            </button>
            <button v-else @click="courseIsOk(true)" class="btn btn-sm btn-success mr-1" :disabled="loading">
                <i class="fa fa-check-circle" /> Aprovar Curso
            </button>
            <button
              class="btn btn-sm btn-primary"
              type="button"
              data-toggle="collapse"
              :data-target="`#course-${ course.id }`"
              aria-expanded="false"
              :aria-controls="`course-${ course.id }`"
            >
              <i class="fa fa-plus-circle"></i>
            </button>
          </div>
        </div>
      </div>
      <div :id="`course-${ course.id }`" class="card-body col-12 collapse">
        <div class="row">
          <div class="col-12 col-md-2 border-bottom">
            <small><b>ID</b></small>
            <p class="mb-0">{{ course.id }}</p>
          </div>

          <div class="col-12 col-md-6 border-bottom">
            <small><b>Nome</b></small>
            <p class="mb-0">{{ course.name }}</p>
          </div>

          <div class="col-12 col-md-2 border-bottom">
            <small><b>Valor</b></small>
            <p class="mb-0">{{ course.value | formatMoney }}</p>
          </div>

          <div class="col-12 col-md-2 border-bottom">
            <small><b>Carga Horária</b></small>
            <p class="mb-0">{{ course.workload }}</p>
          </div>

          <div class="col-12 col-md-4 border-bottom">
            <small><b>Resumo</b></small>
            <p class="mb-0">{{ course.sumary }}</p>
          </div>

          <div class="col-12 col-md-4 border-bottom">
            <small><b>Requerimentos</b></small>
            <p class="mb-0">{{ course.requirements }}</p>
          </div>

          <div class="col-12 col-md-4 border-bottom">
            <small><b>O Aluno aprenderá</b></small>
            <p class="mb-0">{{ course.will_learn }}</p>
          </div>

          <div class="col-12 border-bottom">
            <small><b>Descrição</b></small>
            <p class="mb-0" style="max-height:200px;overflow-y:auto">{{ course.description }}</p>
          </div>

          <div class="col-12 col-md-3 border-bottom">
            <small><b>Data Criação</b></small>
            <p class="mb-0">{{ course.created_at }}</p>
          </div>

          <div class="col-12 col-md-3 border-bottom">
            <small><b>Aprovado?</b></small>
            <p class="mb-0">{{ course.was_approved ? 'Sim':'Não' }}</p>
          </div>

          <div class="col-12 col-md-3 border-bottom">
            <small><b>Vendivel?</b></small>
            <p class="mb-0">{{ course.is_sellable ? 'Sim':'Não'}}</p>
          </div>

          <div class="col-12 col-md-3 border-bottom">
            <small><b>Ativo?</b></small>
            <p class="mb-0">{{ course.is_actived ? 'Sim':'Não' }}</p>
          </div>

          <div class="col-12 col-md-6 border-bottom">
            <small><b>Token Analytics</b></small>
            <p class="mb-0">{{ course.analytics_id }}</p>
          </div>

          <div class="col-12 col-md-6 border-bottom">
            <small><b>Token Pixel</b></small>
            <p class="mb-0">{{ course.pixel_id }}</p>
          </div>

          <div class="col-12 col-md-4 border-bottom">
            <small><b>Capa</b></small>
            <p class="mb-0" v-if="course.cover"><a :href="mountUrl( course.cover )" target="_blank">{{ course.cover.name }}</a></p>
          </div>

          <div class="col-12 col-md-4 border-bottom">
            <small><b>Imagem</b></small>
            <p class="mb-0" v-if="course.thumbnail"><a :href="mountUrl( course.thumbnail )" target="_blank">{{ course.thumbnail.name }}</a></p>
          </div>

          <div class="col-12 col-md-4 border-bottom">
            <small><b>Video</b></small>
            <p class="mb-0" v-if="course.video"><a :href="mountUrl( course.video )" target="_blank">{{ course.video.name }}</a></p>
          </div>

          <h5 class="col-12 mt-4">Professor</h5>
          <div class="col-12 col-md-2 border-bottom">
            <small><b>ID</b></small>
            <p class="mb-0">{{ course.user.id }}</p>
          </div>
          <div class="col-12 col-md-4 border-bottom">
            <small><b>Nome</b></small>
            <p class="mb-0">{{ course.user.name }}</p>
          </div>
          <div class="col-12 col-md-4 border-bottom">
            <small><b>Email</b></small>
            <p class="mb-0">{{ course.user.email }}</p>
          </div>
          <div class="col-12 col-md-2 border-bottom">
            <small><b>CPF/CNPJ</b></small>
            <p class="mb-0">{{ course.user.document }}</p>
          </div>

          <h5 class="col-12 mt-4">Grade do Curso</h5>
          <div class="w-100 mb-3" v-for="grade in course.modules" :key="grade.id">
            <div class="col-12 border-bottom">
              <small><b>Nome</b></small>
              <h6 class="mb-0">{{ grade.name }}</h6>
            </div>

            <div class="col-12 row" v-for="classe in grade.classes" :key="classe.id">
              <div class="col-12 col-md-2 border-bottom">
                <small><b>ID</b></small>
                <p class="mb-0">{{ classe.id }}</p>
              </div>
              <div class="col-12 col-md-10 border-bottom">
                <small><b>Nome</b></small>
                <p class="mb-0">{{ classe.name }}</p>
              </div>
              <div class="col-12 border-bottom">
                <small><b>Descrição</b></small>
                <p class="mb-0" style="max-height:200px;overflow-y:auto">{{ classe.description }}</p>
              </div>

              <div class="col-12 col-md-6 border-bottom">
                <small><b>Media</b></small>
                <p class="mb-0" v-if="classe.media"><a :href="mountUrl( classe.media )" target="_blank">{{ classe.media.name }}</a></p>
              </div>

              <div class="col-12 col-md-6 border-bottom">
                <small><b>Video</b></small>
                <p class="mb-0" v-if="classe.video"><a :href="mountUrl( classe.video )" target="_blank">{{ classe.video.name }}</a></p>
              </div>
            </div>
          </div>

          <h5 class="col-12">Tags</h5>
          <table class="table table-sm table-responsive-md">
            <thead>
              <tr>
                <th>ID</th>
                <th>Nome</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="tag in course.tag" :key="tag.id">
                <td>{{ tag.id }}</td>
                <td>{{ tag.text }}</td>
              </tr>
            </tbody>
          </table>

          <h5 class="col-12">Pagamentos</h5>
          <table class="table table-sm table-responsive-md">
            <thead>
              <tr>
                <th>ID</th>
                <th>Nome</th>
                <th>Max Parcelas</th>
                <th>Valor Minimo</th>
                <th>Sem Juros?</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="payment in course.payment" :key="payment.id">
                <td>{{ payment.id }}</td>
                <td>{{ payment.type == 'blt' ? 'Boleto':'Cartão de Crédito' }}</td>
                <td>{{ payment.max_installments }}x</td>
                <td>{{ payment.min_value | formatMoney }}</td>
                <td>{{ payment.interest_free ? 'Sim':'Não' }}</td>
              </tr>
            </tbody>
          </table>

          <h5 class="col-12">Cupons</h5>
          <table class="table table-sm table-responsive-md">
            <thead>
              <tr>
                <th>ID</th>
                <th>Cupom</th>
                <th>Tipo Cupom</th>
                <th>Quantidade</th>
                <th>Usados</th>
                <th>Tipo Desconto</th>
                <th>Valor</th>
                <th>Inicio</th>
                <th>Final</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="coupom in course.coupoms" :key="coupom.id">
                <td>{{ coupom.id }}</td>
                <td>{{ coupom.content }}</td>
                <td>{{ coupom.type == 'L' ? 'Link':'Cupom' }}</td>
                <td>{{ coupom.quantity }}</td>
                <td>{{ coupom.usage }}</td>
                <td>{{ coupom.discount_type == 'P' ? 'Percentual':'Valor Fixo' }}</td>
                <td>{{ coupom.discount_type == 'V' ? 'R$':'' }}{{ coupom.discount_value }}{{ coupom.discount_type == 'P' ? '%':'' }}</td>
                <td>{{ coupom.start_date }}</td>
                <td>{{ coupom.finish_date }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Axios from 'axios'
export default {
  props: {
    course: {
      required: true
    }
  },
  data () {
    return {
      loading: false,
      urlApi: process.env.VUE_APP_ROOT_BASE
    }
  },
  methods: {
    courseIsOk: function ( status ) {
      this.loading = true
      Axios.post('/admin/course/approvation', {
        id: this.course.id,
        was_approved: status
      })
        .then( res => {
          this.course.was_approved = status
          console.log( res )
        })
        .catch( err => {
          console.error( err )
        })
        .then( () => {
          this.loading = false
        })
    },

    mountUrl: function (item) {
      if ( item == undefined ) return
      if ( item.type.split('/')[0] == 'video' ) {
        let url = item.url.split('/')
        return `https://player.vimeo.com/video/${ url[2] }?loop=false&amp;byline=false&amp;portrait=false&amp;title=false&amp;speed=true&amp;transparent=0`
      } else {
        return `${ this.urlApi }/${ item.url }`
      }
    },

    typeToText (type) {
      switch (type) {
        case 'TCH':
          return 'Professor'
        case 'STD':
          return 'Aluno'
        case 'SUP':
          return 'Suporte'
        case 'FIN':
          return 'Financeiro'
        case 'ADM':
          return 'Administrador'
        default:
          break;
      }
    }
  }
}
</script>
